import { SVGProps } from 'react';



function FailIndicatorIcon(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 44 44"
            width="1em"
            height="1em"
            {...props}
        >
            <rect width={44} height={44} rx={22} fill="currentColor"/>
            <g
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
            >
                <path d="M18.284 26.906l8.342-8.907M18 18.282l8.907 8.342"/>
            </g>
        </svg>
    );
}

export default FailIndicatorIcon;
